var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TrainerLayout',[_c('div',{staticClass:"container mx-auto px-4"},[_c('UpcomingSessionsCard',{attrs:{"data":_vm.trainerSessionList,"routerLink":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }